import { Component, OnInit } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { SelectOrganizationDialogComponent } from '../organization/select-organization-dialog/select-organization-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/auth.service';
import { UserDataService } from 'src/app/services/user-data-service';
import { UserService } from 'src/app/services/user.service';
import { SessionTimeoutService } from 'src/app/services/session-timeout.service';
@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent implements OnInit {
  private previousUserData: string | null = null; // To track changes in userData
  iconName: string = 'arrow_left'; // default icon
  role:Number=0;
 // Class-level properties
  userData: any; 
  userOrgData: any;
  constructor( private matDialog: MatDialog,
                private authService: AuthService,
                private userDataService:UserDataService,
                private userService: UserService,
                private sessionTimeoutService: SessionTimeoutService
  ) {
  }
  ngOnInit(): void {
    this.logUserData(); // Initial log
  }
  /**
   * Logs user data only when there's a change.
   */
  private logUserData(): void {
    this.userData = localStorage.getItem('userData');
    this.userOrgData = localStorage.getItem('userOrgs');

    const user = this.authService.getUserDetails();
    if(user){
      this.role =user.userType ;
      const selectedOrganizationId = localStorage.getItem('selectedOrganizationId');

      if (this.userOrgData) {
        try {
          const parsedUserOrgData = JSON.parse(this.userOrgData); // Parse to JSON
          this.logSelectedOrganization(parsedUserOrgData, selectedOrganizationId || '');
        } catch (error) {
          console.error('Failed to parse userOrgData:', error);
        }
      } else {
        console.log('No userOrgData found in localStorage.');
      }

      if (this.userData !== this.previousUserData) {
        this.previousUserData = this.userData; // Update the reference
      }
    }
  }
  /**
   * Logs the matched organization based on the selectedOrganizationId.
   * @param userOrgData - Array of organization objects.
   * @param selectedOrganizationId - ID of the selected organization.
   */
  private logSelectedOrganization(userOrgData: any[], selectedOrganizationId: string): void {
   // console.log("userOrgData==", userOrgData);
  //  console.log("selectedOrganizationId==", selectedOrganizationId);
  
    // Convert selectedOrganizationId to a number if it's a string (or vice versa, depending on your data)
    const selectedOrgIdNum = Number(selectedOrganizationId);
  
    // Find the specific object with the matching selectedOrganizationId
    const selectedOrganization = userOrgData.find(org => org.organizationId === selectedOrgIdNum);
  
    if (selectedOrganization) {
     // console.log("Matched Organization Data:", selectedOrganization);
    } else {
     // console.log("No matching organization found for ID:", selectedOrgIdNum);
    }
  }
 /**
   * Checks if the user is logged in and has a specific role (based on selected organization roleId).
   * @returns True if logged in and selected organization roleId is 1; otherwise, false.
   */
  isLoggedInAndHasRole(): boolean {
    const selectedOrganization = this.userDataService.getSelectedOrganization();
    if (!selectedOrganization) {
      return false;
    }
    const selectedOrganizationId =selectedOrganization.toString();
    if(selectedOrganizationId==='0')
    {
      return true; // Show menu or return true based on your desired behavior when selectedOrganizationId is '0'
    }
    else
    {  
      if (this.userData && this.userOrgData && selectedOrganizationId) {
        const user = JSON.parse(this.userData);
        const parsedUserOrgData = JSON.parse(this.userOrgData);
        const selectedOrgIdNum = Number(selectedOrganizationId);
    
        // Find the selected organization from the parsed userOrgData
        const selectedOrganization = parsedUserOrgData.find(org => org.organizationId === selectedOrgIdNum);
    
        if (selectedOrganization) {
          // Check if the selected organization's roleId is 1
          return selectedOrganization.roleId === 1 || selectedOrganization.roleId === 2;
        }
      }
      return false; // Not logged in or role doesn't match
    }
  }
  hasMultipleOrganizations(): boolean {
    const userData = localStorage.getItem('userData');
    //const orgData = this.userOrgData;
   // const parsedOrgData = JSON.parse(orgData);
   // const parsedOrgDataLength = parsedOrgData.length;

    if (userData) {
      const user = JSON.parse(userData);
      const isUserTypeValid = user.userType !== 0; // Check for roles other than 1
    
      if (isUserTypeValid) {
        const orgData = this.userOrgData; // Assuming orgData is already available
        const parsedOrgData = Array.isArray(orgData) ? orgData : JSON.parse(orgData); // Parse if necessary
    
        if (parsedOrgData.length > 1) {
          return true; // Length of parsedOrgData is greater than 1
        }
      }
    }
    return false; // Not logged in or conditions not met

  }
  changeOrg(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '300px';
    dialogConfig.maxWidth = '90vw';

   //const organizations= this.userOrgData;
   const organizations=this.userOrgData ? JSON.parse(this.userOrgData) : {};
  // console.log(organizations);
   // Pass the organization data to the dialog
   dialogConfig.data = { organizations,moduletype:'change'}; 
    const dialogRef = this.matDialog.open(SelectOrganizationDialogComponent, dialogConfig);
  
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        if (result.status === true) {
          console.log('Organization selected successfully.');
          await this.applyOrganizationToSession(organizations, result.organizationId);
        } else if (result.status === false) {
          console.log('Organization selection failed.');
        }
      }
    });
  }
  // Same server-session and timeout steps the login flow runs after an organization is
  // selected (LoginComponent.OpenEntryDialog). Without them, a change made here left
  // the server session on the previous organization (uploads were stored under it) and
  // kept the previous organization's session timeout.
  private async applyOrganizationToSession(organizations: any[], organizationId: number): Promise<void> {
    const roleId = organizations.find(org => org.organizationId === organizationId)?.roleId;
    if (roleId === undefined || roleId === null) {
      return;
    }
    try {
      await this.userService.selectOrganizationSession(organizationId, roleId);
      const sessionResponse: any = await this.userService.getSessionTimeoutsByOrgRole(organizationId, roleId).toPromise();
      const timeout = sessionResponse && 'timeout' in sessionResponse
        ? sessionResponse.timeout
        : Array.isArray(sessionResponse) && sessionResponse.length > 0 ? sessionResponse[0].timeout : undefined;
      if (timeout !== undefined) {
        this.userDataService.setUserSessionTimeoutData(timeout);
        this.sessionTimeoutService.start();
      } else {
        console.warn('No session timeout data found for this role.');
      }
    } catch (err) {
      console.error('Error applying organization to session:', err);
    }
  }

   /**
   * Checks if the user is logged in and has a specific role (based on selected organization roleId).
   * @returns True if logged in and selected organization roleId is 1; otherwise, false.
   */
  isLoggedIn(): boolean {
    return this.authService.getLoginStatus(); // Call the AuthService method to check login status
  }

  isSuperAdmin(): boolean {
    const user = this.authService.getUserDetails();
    return user !== null && user.userType === 1;
  }
}
